import NIM from './NIM_Web_NIM_v9.5.0';
import store from '@/store/state.js'
import Vue from 'vue';
export default class IMController {
  constructor(headers) {
    Vue.prototype.Im = NIM.getInstance({
      // 初始化SDk
      // debug: true,
      appKey: '4b230a9fd12f99f2f3ddab2211cb6f4a',
      token: headers.token,
      account: headers.account,
      promise: true,
      transports: ['websocket'],
      syncSessionUnread: true, // 同步未读数
      onconnect: this.onConnect,
      onwillreconnect: this.onWillReconnect,
      ondisconnect: this.onDisconnect,
      onerror: this.onError, // 同步完成
      onsyncdone: this.onSyncDone,
      // 用户关系
      onblacklist: this.onBlacklist,
      onsyncmarkinblacklist: this.onMarkInBlacklist,
      onmutelist: this.onMutelist,
      onsyncmarkinmutelist: this.onMarkInMutelist,
      // 好友关系
      onfriends: this.onFriends,
      onsyncfriendaction: this.onSyncFriendAction,
      // // 用户名片
      onmyinfo: this.onMyInfo,
      onupdatemyinfo: this.onUpdateMyInfo,
      onusers: this.onUsers,
      onupdateuser: this.onUpdateUser,
      // 机器人列表的回调
      onrobots: this.onRobots,
      // 群组
      onteams: this.onTeams,
      onsynccreateteam: this.onCreateTeam,
      onupdateteammember: this.onUpdateTeamMember,
      onAddTeamMembers: this.onAddTeamMembers,
      onRemoveTeamMembers: this.onRemoveTeamMembers,
      onUpdateTeam: this.onUpdateTeam,
      onUpdateTeamManagers: this.onUpdateTeamManagers,
      onDismissTeam: this.onDismissTeam,
      onTransferTeam: this.onTransferTeam,
      onUpdateTeamMembersMute: this.onUpdateTeamMembersMute,
      shouldCountNotifyUnread: this.shouldCountNotifyUnread,
      // 会话
      onsessions: this.onSessions,
      onupdatesession: this.onUpdateSession,
      // 消息
      onroamingmsgs: this.onRoamingMsgs,
      onofflinemsgs: this.onOfflineMsgs,
      onmsg: this.onMsg,
      // 系统通知
      onofflinesysmsgs: this.onOfflineSysMsgs,
      onsysmsg: this.onSysMsg,
      onupdatesysmsg: this.onUpdateSysMsg,
      onsysmsgunread: this.onSysMsgUnread,
      onupdatesysmsgunread: this.onUpdateSysMsgUnread,
      onofflinecustomsysmsgs: this.onOfflineCustomSysMsgs,
      oncustomsysmsg: this.onCustomSysMsg,
      // 收到广播消息
      onbroadcastmsg: this.onBroadcastMsg,
      onbroadcastmsgs: this.onBroadcastMsgs,
      disconnect: this.disconnect,
    })
  }
  /** 1
   * 连接成功
   */
  onConnect(res) {
    console.log(' onConnect: ', res)
    // app.globalData.netcallController = new NetcallController({
    //   // debug: false,
    //   debug: true,
    //   nim: app.globalData.nim
    // })
  }
  /** 2或sync done之后触发
   * 设置订阅后，服务器消息事件回调
   */
  disconnect(r) {
    console.log(' disconnect: ', r)
  }
  /** 3
   * 收到黑名单列表
   */
  onBlacklist(blacklist) {
    console.log(' onBlacklist: ', blacklist)

  }
  /** 4
   * onMutelist
   */
  onMutelist(mutelist) {
    console.log(' onMutelist: ', mutelist)
  }
  /** 5
   * 同步好友信息，不含名片 [{account, createTime, updateTime}]
   */
  onFriends(friends) {
    console.log(' onFriends: ', friends)

  }
  /** 6
   * 个人名片：存储个人信息到全局数据
   */
  onMyInfo(user) {
    console.log(' onMyInfo: ', user)
    store.state.$userinfo = user;

  }
  /** 7
   * 包含名片的好友信息（可能某些字段不全），[{account,avatar,birth,createTime,email,gender,nick,sign,updateTime}]
   */
  onUsers(friends) {
    console.log(' onUsers: ', friends)

  }
  /** 8 同步群列表
   * onTeams
   */
  onTeams(teams) {
    console.log('onTeams')
    console.log(teams)

  }
  /** 9
   * onSyncDone,同步完成
   */
  onSyncDone() {
    console.log(' Sync Done')

  }
  /**
   * 会话更新：收到消息、发送消息、设置当前会话、重置会话未读数 触发
   * {id:'p2p-zys2',lastMsg:{},scene,to,unread,updateTime}
   * {id:'team-1389946935',lastMsg:{attach:{accounts,team},type,users},scene,to,from,type,unread,updateTime}
   */
  onUpdateSession(session) {
    console.log('onUpdateSession: ', session)
    // try {
    //   store.dispatch({
    //     type: 'UnreadInfo_update',
    //     payload: session
    //   })
    // } catch (error) {
    // }
    // store.state.$imList.msgs.push(session.lastMsg);
  }
  /**
   * 收到消息
   * {cc,flow:"in",from,fromClientType:"Web",fromDeviceId,fromNick,idClient,idServer:"9680840912",isHistoryable:true,isLocal,isMuted, isOfflinable,isPushable,isRoamingable,isSyncable,isUnreadable,needPushNick,resend,scene:"p2p",sessionId:"p2p-zys2",status:"success",target:"zys2",text:"[呕吐]",time,to:"wujie",type:"text",userUpdateTime}
   */
  onMsg(msg) {
    console.log('onMsg: 收到消息', msg);
    if ('p2p-' + msg.target == store.state.$imList.sessionId) {
      store.state.$imList.msgs.push(msg);
      store.state.$onMsg = !store.state.$onMsg;
    }
    if (store.state.$newList.some(item => {
      return item.id == msg.sessionId
    })) {
      store.state.$newList.forEach(item => {
        if (item.id == msg.sessionId) {
          item.lastMsg = msg
          item.unread = 1;
        }
      });
    } else {
      store.state.$newList.push({
        id: msg.sessionId,
        lastMsg: msg,
        nick: msg.fromNick,
        scene: "p2p",
        to: msg.target,
        unread: 1,
        updateTime: msg.time
      })
    }
  }
  /** 操作主体为对方
   * 收到系统通知，例如 被对方删除好友、被对方添加好友、被对方撤回消息
   * {type,to,time,deletedMsgTime,deletedMsgFromNick,deletedIdServer,deletedIdClient,status,scene,opeAccount,msg:{flow,from,fromNick,idClient,scene,sessionId,target,time,to,opeAccount},idServer,from}
   * time:为删除消息时间，deletedMsgTime为删除的消息发送时间
   */
  onSysMsg(msg) {
    console.log('onSysMsg: ', msg)
  }
  /**
   * 丢失连接
   */
  onDisconnect(error) {
    console.log(' onDisconnect: ')
    console.log(error)

  }
  /**
   * 漫游消息：会多次收到，每次只会收到指定人的漫游消息
    // {scene:"p2p",sessionId:"p2p-cs4",timetag:1513153729257,to:"cs4",msg:[{from:'wujie',text:'222',to:'cs4'}]}
    // {scene:"team",sessionId:"team-3944051",timetag:1513153729257,to:"3944051",msg:[{from:'wujie',text:'222',to:'cs4'}]}
   */
  onRoamingMsgs(list) {
    console.log('漫游消息', list);
    let imList = store.state.$imList;
    store.state.$imList = {};
    imList[list.sessionId] = list;
    store.state.$imList = imList;
  }
  /**
   * 连接出错
   */
  onError(error) {
    console.log(' onError', error)

  }

  onMarkInBlacklist(obj) {
    console.log(' onMarkInBlacklist: ')
    console.log(obj)
  }

  onMarkInMutelist(obj) {
    console.log(' onMarkInMutelist: ')
    console.log(obj)
  }

  onSyncFriendAction(obj) {
    console.log(' onSyncFriendAction')
    console.log(obj)
  }

  onUpdateMyInfo(user) {
    console.log(' onUpdateMyInfo')
    console.log(user)
  }

  onUpdateUser(user) {
    console.log(' onUpdateUser')
    console.log(user)
  }

  /**
   *   创建群的回调, 此方法接收一个参数, 包含群信息和群主信息
   */
  onCreateTeam(team) {
    console.log(' onCreateTeam', team)

  }
  /**
   *  群成员信息更新后的回调, 会传入群成员对象, 不过此时的信息是不完整的, 只会包括被更新的字段。当前登录帐号在其它端修改自己的群属性时也会收到此回调。
   */
  onUpdateTeamMember(teamMember) {
    console.log('onUpdateTeamMember', teamMember)

  }
  /**
   *  新成员入群的回调，自己建群成功也回调
   */
  onAddTeamMembers(msg) {
    console.log('onAddTeamMembers', msg)

  }
  /**
   *  有人出群的回调
   */
  onRemoveTeamMembers(msg) {
    console.log('onRemoveTeamMembers', msg)

  }
  /**
   *  更新群的回调
   */
  onUpdateTeam(msg) {
    console.log('onUpdateTeam', msg)

  }
  /**
   *  更新群管理员的回调
   */
  onUpdateTeamManagers(msg) {
    console.log('onUpdateTeamManagers', msg)

  }
  /**
   *  解散群的回调
   */
  onDismissTeam(msg) {
    console.log('onDismissTeam', msg)

  }
  /**
   *  移交群的回调
   */
  onTransferTeam(msg) {
    console.log('onTransferTeam', msg)

  }
  /**
   *  更新群成员禁言状态的回调
   */
  onUpdateTeamMembersMute(msg) {
    console.log('onUpdateTeamMembersMute', msg)

  }
  /**
   *  群消息通知是否加入未读数开关如果返回true，则计入未读数，否则不计入
   */
  shouldCountNotifyUnread(msg) {
    console.log('shouldCountNotifyUnread')
    console.log(msg)

    return true
  }
  /**会话
   * [ {id:"p2p-liuxuanlin",lastMsg:{from:'wujie',text:'222',to:"liuxuanlin"}} ]
   */
  onSessions(sessions) {
    console.log('onSessions: ', sessions)
    store.state.$newList = sessions;
    console.log(NIM, 1)
    store.state.$newList = sessions

  }
  onOfflineMsgs(msg) {
    console.log(' onOfflineMsgs')
    console.log(msg)

  }
  // 系统通知
  onOfflineSysMsgs(msg) {
    console.log(' onOfflineSysMsgs')
    console.log(msg)
  }
  onUpdateSysMsg(sysMsg) {
    console.log(' onUpdateSysMsg')
    console.log(sysMsg)

  }
  onCustomSysMsg(sysMsg) {
    console.log(' onCustomSysMsg')
    console.log(sysMsg)
    //多端同步 正在输入自定义消息类型需要过滤

  }
  onSysMsgUnread(obj) {
    console.log(' onSysMsgUnread')
    console.log(obj)
  }
  onUpdateSysMsgUnread(obj) {
    console.log(' onUpdateSysMsgUnread')
    console.log(obj)
  }
  onOfflineCustomSysMsgs(sysMsg) {
    console.log(' onOfflineCustomSysMsgs')
    console.log(sysMsg)
  }
  // 收到广播消息
  onBroadcastMsg(msg) {
    console.log('onBroadcastMsg: ', msg)
  }
  onBroadcastMsgs(msg) {
    console.log('onBroadcastMsgs: ', msg)
  }
  /**
   * 断开重连
   */
  onWillReconnect(obj) {
    console.log(' onWillReconnect', obj)
  }
}
